async function ReArrangeLabel(originalData, keyToRename, newKeyName) {
      // Map over the original array and transform each object
      const rearrangedData = originalData?.map((item) => {
        // Destructure the item to extract the value of the key to rename
        const { [keyToRename]: originalValue, ...rest } = item;
  
        // Create a new object with the renamed key and other remaining properties
        return {
          [newKeyName]: String(originalValue), // Rename the key
          value: originalValue,
          ...rest, // Spread the remaining properties
        };
      });
  
      return rearrangedData;
    }
    export default ReArrangeLabel